
import CryptoJS from "crypto-js";

const keyStr = process.env.REACT_APP_PRIVATE_KEY;
const ivStr = process.env.REACT_APP_PRIVATE_VI;

 


export const encrypt = (data) => {
  
  if (typeof data !== "string") {
    throw new Error("encrypt() expects a string as input");
  }
 let encrypted = ""
  try {
    const key = CryptoJS.enc.Latin1.parse(keyStr); 
const iv = CryptoJS.enc.Latin1.parse(ivStr); 
     encrypted = CryptoJS.AES.encrypt(data, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    
  });
  } catch (error) {
     console.log("error",error)
  }

  return encrypted.toString(); 
};


export const decrypt = (encryptedData) => {
    
 let decrypted = ""
    try {
        const key = CryptoJS.enc.Latin1.parse(keyStr); 
const iv = CryptoJS.enc.Latin1.parse(ivStr); 
 decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
    } catch (error) {
         console.log("error",error)
    }

  
  return decrypted.toString(CryptoJS.enc.Utf8);
};